export const TableDetails = ({
    appTheme,
    item,
    millisecondsToHuman
}) => {
    return (
        <div className={`linear-table-details rounded ${appTheme === "light"? "border":""}`}>
            <thead>
                <tr>
                    <th>Total scheduled</th>
                    <th className="text-center">No</th>
                    <th className="text-center">HH:MM:SS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="d-flex align-items-center"><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Total Scheduled</td>
                    <td className="text-center px-0">{item?.scheduleItems.length + item?.scheduleItems?.reduce((total, item) => total + (item?.adBreaksCount || 0), 0)}</td>
                    <td className="text-center">{millisecondsToHuman(item?.scheduleItems?.reduce((total, data) => total + (data?.totalDuration || 0), 0))}</td>
                </tr>
                <tr>
                    <td className="d-flex align-items-center"><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Videos</td>
                    <td className="text-center px-0">{item?.scheduleItems.length}</td>
                    <td className="text-center">{millisecondsToHuman(item?.scheduleItems?.reduce((total, data) => total + (data?.duration || 0), 0))}</td>
                </tr>
                <tr>
                    <td className="d-flex align-items-center"><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Ads</td>
                    <td className="text-center px-0">
                        {
                            item?.scheduleItems.reduce(
                            (total, si) =>
                                total +
                                (si?.adBreaks?.filter(ad => ad?.type === "filler").length || 0),
                            0
                            )
                        }
                        </td>

                        <td className="text-center">
                        {
                            millisecondsToHuman(
                            item?.scheduleItems
                                ?.flatMap(si => si.adBreaks || [])
                                .filter(ad => ad.type === "filler") // ✅ only filler
                                .reduce((total, adBreak) => total + (adBreak.duration || 0), 0)
                            )
                        }
                    </td>
                </tr>
                <tr>
                    <td className="d-flex align-items-center"><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Promos</td>
                    <td className="text-center px-0">
                        {
                            item?.scheduleItems.reduce(
                            (total, si) =>
                                total +
                                (si.adBreaks?.filter(ad => ad.type === "promo").length || 0),
                            0
                            )
                        }
                        </td>

                        <td className="text-center">
                        {
                            millisecondsToHuman(
                            item?.scheduleItems
                                ?.flatMap(si => si.adBreaks || [])
                                .filter(ad => ad.type === "promo") // ✅ only filler
                                .reduce((total, adBreak) => total + (adBreak.duration || 0), 0)
                            )
                        }
                    </td>
                </tr>
            </tbody>
        </div>
    )
}